<template>
  <a
    v-if="query"
    :href="href"
    target="_blank"
    rel="noopener"
    class="ytcid-link"
    :title="`YouTube Content ID에서 '${query}' 검색`"
  >
    <span class="ytcid-link__dot" aria-hidden="true"></span>
    <span class="ytcid-link__label">Content ID 검색</span>
  </a>
</template>

<script>
export default {
  name: 'YtCidSearchLink',
  props: {
    query: { type: String, default: '' },
  },
  computed: {
    href() {
      return `/youtube-cid?q=${encodeURIComponent(this.query || '')}`
    },
  },
}
</script>

<style lang="scss" scoped>
.ytcid-link {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  padding: 10px 16px 8px 15px;
  margin: 8px 0 0 12px;
  border: 1px solid rgba(15, 30, 60, 0.12);
  border-radius: 16px;
  background: transparent;
  color: rgba(26, 34, 53, 0.66);
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.015em;
  text-decoration: none;
  cursor: pointer;
  transition: border-color 140ms ease, color 140ms ease;

  &:hover,
  &:focus-visible {
    border-color: rgba(15, 30, 60, 0.26);
    color: rgba(26, 34, 53, 0.92);
    text-decoration: none;
  }

  &:focus-visible {
    outline: none;
    border-color: #FF0000;
  }
}

.ytcid-link__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #FF0000;
  flex-shrink: 0;
}

.ytcid-link__label {
  white-space: nowrap;
}
</style>
